export enum SOCKET_NAME_SPACES {
  SESSIONS = "sessions",
  NOTIFICATIONS = "notifications",
  CHAT = "chat",
  PAYROLL = "payroll",
}

export enum SOCKET_PAYROLL_EVENTS {
  SUBSCRIBE = "payroll.run.subscribe",
  UNSUBSCRIBE = "payroll.run.unsubscribe",
  RUN_PROGRESS = "payroll.run.progress",
  RUN_ITEM = "payroll.run.item",
  RUN_COMPLETED = "payroll.run.completed",
  PROCESS_STARTED = "payroll.process.started",
  PROCESS_FILE = "payroll.process.file",
  PROCESS_COMPLETED = "payroll.process.completed",
  PROCESS_FAILED = "payroll.process.failed",
  SIGNATURE_EMAIL_STARTED = "payroll.signature_email.started",
  SIGNATURE_EMAIL_PROGRESS = "payroll.signature_email.progress",
  SIGNATURE_EMAIL_COMPLETED = "payroll.signature_email.completed",
  SIGNATURE_EMAIL_FAILED = "payroll.signature_email.failed",
}

export enum SOCKET_SESSION_EVENTS {
  CONNECTED = "connected",
  HEARTBEAT_ACK = "heartbeat_ack",
  SESSION_TERMINATED = "session_terminated",
  ERROR = "session_error",
  NEW_DEVICE_LOGIN = "new_device_login",
  DEVICE_LOGOUT = "device_logout",
  UPLOADED_FILE_QR = "uploaded_file_qr",
  MAINTENANCE_MODE_CHANGED = "maintenance_mode_changed",
}

export enum SOCKET_NOTIFICATION_EVENTS {
  CONNECTED = "connected",
  NEW_NOTIFICATION = "new_notification",
  NEW_ANNOUNCEMENT_NOTIFICAITON = "new_announcement_notification",
  TOKEN_BALANCE_UPDATED = "token_balance_updated",
  PERMISSIONS_CHANGED = "permissions_changed",
}

/** Namespace `/chat` (api.maihrms.com ChatEvent / ChatClientEvent). */
export enum SOCKET_CHAT_EVENTS {
  MESSAGE_NEW = "message_new",
  MESSAGE_UPDATED = "message_updated",
  CONVERSATION_UPDATED = "conversation_updated",
  CONVERSATION_REMOVED = "conversation_removed",
  READ = "message_read",
  /** A member's devices received everything up to an id (the double tick). */
  DELIVERED = "message_delivered",
  /** Someone (never the sender) played a voice note. */
  PLAYED = "message_played",
  TYPING = "user_typing",
  PRESENCE = "presence",
  /** Only to the sender's own sockets: their scheduled list for a chat changed. */
  SCHEDULED_UPDATED = "scheduled_updated",
  /** Only to me: my chat settings changed on another device (e.g. a channel notice answer). */
  SETTINGS_UPDATED = "settings_updated",
  /** Only to a message's author: someone else reacted to it (IChatReactionEvent). */
  REACTION_NEW = "reaction_new",
  // Client → server
  TYPING_START = "typing_start",
  TYPING_STOP = "typing_stop",
  PRESENCE_SUBSCRIBE = "presence_subscribe",
  PRESENCE_UNSUBSCRIBE = "presence_unsubscribe",
}
